import React, { useState } from "react";
import { useAppSelector } from "app/hooks";
import { selectUserIsAdmin } from "features/auth/authSlice";
import ProfileUserData from "./ProfileUserData";
import ChangePasswordDialog from "./ChangePasswordDialog";
import { Box, IconButton, Tooltip } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import PageLayout from "components/PageLayout";
import OutlinedCard from "components/OutlinedCard";
import PageTitle from "components/PageTitle";
import { useAuthContext } from "features/auth/AuthContext";
import UserProvider from "context/UserContext";
import ErrorPage from "pages/error/ErrorPage";
import UpsertUserDialog from "dialogs/UpsertUserDialog";

const Profile: React.FC = () => {
  const { user } = useAuthContext();
  const isAdmin = useAppSelector(selectUserIsAdmin);
  const [changePasswordOpen, setChangePasswordOpen] = useState<boolean>(false);
  const [editProfileOpen, setEditProfileOpen] = useState<boolean>(false);

  const openChangePasswordModal = () => {
    setChangePasswordOpen(true);
  };

  if (!user) return <ErrorPage.NotFound />;

  return (
    <PageLayout>
      <PageTitle>{user.userName}</PageTitle>

      <OutlinedCard>
        <Box sx={{ float: "right" }}>
          {isAdmin && (
            <Tooltip arrow title="Redigera dina uppgifter">
              <IconButton onClick={() => setEditProfileOpen(true)}>
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          <Tooltip arrow title="Ändra lösenord">
            <IconButton onClick={openChangePasswordModal}>
              <VpnKeyIcon />
            </IconButton>
          </Tooltip>
        </Box>

        <UserProvider user={user}>
          <ProfileUserData />

          {editProfileOpen && (
            <UpsertUserDialog user={user} onClose={() => setEditProfileOpen(false)} />
          )}
        </UserProvider>

        {changePasswordOpen && (
          <ChangePasswordDialog onClose={() => setChangePasswordOpen(false)} />
        )}
      </OutlinedCard>
    </PageLayout>
  );
};

export default Profile;
